var _path, _path2, _path3, _path4, _polygon, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _path5, _circle4, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect4, _circle5, _circle6, _path15, _path16, _path17, _path18, _polygon2, _path19, _polygon3, _path20, _path21, _path22, _path23, _path24, _circle7, _path25, _circle8, _path26, _path27, _path28;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawTravelBookingRe6Umu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 936.21021,
    height: 603.71798,
    viewBox: "0 0 936.21021 603.71798",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.29922,705.87622c-12.67046-3.5-18.07743,15.7409-5.43893,19.3527C208.53016,728.72878,213.93713,709.48789,201.29922,705.87622Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M271.55041,730.6406c-12.67046-3.5-18.07743,15.7409-5.43893,19.3527C278.78135,753.49316,284.18832,734.25226,271.55041,730.6406Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M299.98217,527.71029l-.1959-.05507-32.636,88.60423L262.84748,615.05l32.87007-89.23975h0a6.03524,6.03524,0,0,1,5.04752-5.6433c16.32125-2.58087,22.93706,11.90731,22.93706,11.90731l-.0653.09632-33.36652,90.58729-4.30277-1.20938,32.38461-87.92189C308.49319,523.87528,299.98217,527.71029,299.98217,527.71029Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M262.25841,735.62283c-19.2371-.29351-43.026-10.68862-59.24586-18.48134a20.21812,20.21812,0,0,1-10.71508-23.73628l21.02117-74.788a25.40559,25.40559,0,0,1,12.61738-15.5655,24.32712,24.32712,0,0,1,19.41066-1.49916c.75061.3375,21.17239,6.053,34.6861,9.8349,7.94979,2.225,13.6938,3.83278,14.07838,3.962.31826.10517,14.60491,5.01369,12.06954,22.27425-1.94732,13.25663-16.644,62.10532-22.8726,82.49273A21.86326,21.86326,0,0,1,262.578,735.62489C262.47218,735.62489,262.3646,735.6242,262.25841,735.62283Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#ffa84d"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "70.651 556.664 97.904 464.42 161.991 482.531 162.374 481.177 96.948 462.687 96.751 463.354 69.301 556.265 70.651 556.664",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "f269d402-b375-49c3-b6cb-02ffddd7443c",
    "data-name": "Rectangle 62",
    x: 374.84173,
    y: 15.39029,
    width: 561.36848,
    height: 266.37908,
    fill: "#e5e5e5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "a67a6d8d-d730-43ea-8e97-5097e31b093a",
    "data-name": "Rectangle 75",
    x: 391.5611,
    y: 38.23276,
    width: 529.26423,
    height: 222.2484,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "f3270c98-3f14-4116-bb63-3583a595f2eb",
    "data-name": "Rectangle 80",
    x: 374.60236,
    width: 561.36848,
    height: 23.8486,
    fill: "#ffa84d"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "aeafa2cf-3960-41d9-9a79-114ebb97b926",
    "data-name": "Ellipse 90",
    cx: 392.32484,
    cy: 11.88015,
    r: 4.42025,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "e013fb1c-e2d9-4cba-be1c-2b59a1ea1400",
    "data-name": "Ellipse 91",
    cx: 409.10265,
    cy: 11.88015,
    r: 4.42025,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "a6347b87-b687-4c13-8a45-efd6144b746c",
    "data-name": "Ellipse 92",
    cx: 425.88124,
    cy: 11.88015,
    r: 4.42025,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M773.28978,294.414a83.99166,83.99166,0,0,1-5.2939,29.45249,81.6859,81.6859,0,0,1-5.85064,12.4741,84.38172,84.38172,0,0,1-146.423,0q-1.12179-1.94466-2.12754-3.9475A84.363,84.363,0,1,1,773.28978,294.414Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#f1f1f1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.42447,
    cy: 144.38691,
    r: 16.12715,
    fill: "#ffa84d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M613.59478,332.39313c7.10549-7.67892,16.60442-19.87046,25.5133-11.0613,4.47106,4.15526,11.46852,14.452,18.1668,7.72047l52.30641-52.30642a10.38416,10.38416,0,0,1,14.85091.26594L767.996,323.86653a81.71185,81.71185,0,0,1-5.85061,12.4741H615.72227Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "f2fac30d-751a-4ad9-9a70-d842b6b29c55-171",
    "data-name": "Path 680",
    d: "M945.55,277.88725a2.1793,2.1793,0,0,0,0,4.3586h22.86857a2.1793,2.1793,0,0,0,0-4.3586Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#ffa84d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "bff7eaac-8fd0-4862-b46f-daee6d731cf9-172",
    "data-name": "Path 680",
    d: "M842.52039,245.87806a2.1793,2.1793,0,1,0,0,4.35859H969.41884a2.1793,2.1793,0,0,0,0-4.35859Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#e5e5e5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "a9efcef9-bf26-45a4-a9d0-ef067b9cf824-173",
    "data-name": "Path 680",
    d: "M842.52039,261.88266a2.1793,2.1793,0,1,0,0,4.35859H969.41884a2.1793,2.1793,0,0,0,0-4.35859Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#e5e5e5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "b479989b-99d4-4e70-bae9-0a98ba95b9e4-174",
    "data-name": "Path 680",
    d: "M945.55,380.58342a2.1793,2.1793,0,0,0,0,4.35859h22.86857a2.1793,2.1793,0,1,0,0-4.35859Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#ffa84d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "b7ed51b3-7b2d-4a2d-a8c2-cf48ecd6b6d7-175",
    "data-name": "Path 680",
    d: "M842.52039,348.57422a2.1793,2.1793,0,0,0,0,4.3586H969.41884a2.1793,2.1793,0,0,0,0-4.3586Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#e5e5e5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "e2a2d7bb-cfae-451b-8ad9-ee9abc29fc00-176",
    "data-name": "Path 680",
    d: "M842.52039,364.57882a2.1793,2.1793,0,1,0,0,4.35859H969.41884a2.17929,2.17929,0,0,0,0-4.35859Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#e5e5e5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M918.69564,221.46039h-6.87259l-5.89843-8.45294h-2.49568l2.962,8.45294h-6.72339v0l-2.75943-2.7595h-2.33455l1.16526,5.10511-1.16526,4.46272h2.33455l2.75943-2.75951.04369-.07281h6.75791l-3.04025,8.67569h2.49568l5.92283-8.48785.07017-.18784h6.778a1.988,1.988,0,1,0,0-3.976Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#e5e5e5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M912.87,331.75484H902.01162a3.67187,3.67187,0,0,1-3.66772-3.66772v-9.87784a2.98292,2.98292,0,0,1,2.1961-2.89406,26.82551,26.82551,0,0,1,13.77447.00977,2.988,2.988,0,0,1,2.22329,2.90285v9.85928A3.67187,3.67187,0,0,1,912.87,331.75484Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#e5e5e5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 768.53513,
    y: 170.42729,
    width: 14.02158,
    height: 5.25809,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 770.28783,
    cy: 179.19077,
    r: 1.7527,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 780.80401,
    cy: 179.19077,
    r: 1.7527,
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M915.807,336.75628H898.886l4.0011-3.3343h8.91881Zm-14.28982-.95266h11.65862l-1.71482-1.429h-8.229Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#e5e5e5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M916.6825,332.4217h-18.672a1.00029,1.00029,0,0,1,0-2.00058h18.672a1.00029,1.00029,0,0,1,0,2.00058Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#e5e5e5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M315.96886,535.19749a9.13774,9.13774,0,0,0-5.6783-12.80957l-1.75666-32.42511-13.564,10.03825,3.74767,29.25246a9.18732,9.18732,0,0,0,17.25129,5.944Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#ffb7b7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M421.04953,541.23119a9.13781,9.13781,0,0,1,3.63561-13.53184L421.422,495.39107l14.9494,7.82714.80687,29.4805a9.18732,9.18732,0,0,1-16.12869,8.53248Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#ffb7b7"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "209.375 591.715 220.055 591.714 225.137 550.517 209.373 550.517 209.375 591.715",
    fill: "#ffb7b7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M338.54494,736.36845l21.0344-.00085h.00085A13.40548,13.40548,0,0,1,372.985,749.77215v.4356l-34.43937.00128Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "263.319 585.3 273.763 587.538 287.364 548.319 271.95 545.017 263.319 585.3",
    fill: "#ffb7b7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M393.28048,729.4602l20.56758,4.40685.00083.00018a13.40549,13.40549,0,0,1,10.29829,15.91587l-.09128.42593-33.675-7.2154Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M322.01233,504.09433s-11.36341,35.11909-.23485,74.83265l11.32676,47.5724,2.81107,105.26285,22.93669-7.3624L368.19658,563.843l43.04169,73.05761-22.65352,87.49922,26.05155.84951,28.132-94.62678-24.73393-88.30041-4.53071-21.52084Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M414.87614,387.46289,392.062,374.45883l-39.46845-2.28141-27.377,14.3729,11.12581,76.32934s-21.21955,30.4544-13.4831,50.74537c9.54868,25.044,93.04583,38.10906,91.41261,13.66818-2.57739-38.57009-6.55754-35.90994-9.4757-54.82368-3.202-20.75321,19.20557-47.36333,19.20557-47.36333Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#cbcbcb"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M333.65783,394.079l-2.54319-11.02162s-10.84929,1.40441-18.36806,22.40544-20.88414,65.27166-20.88414,65.27166l.698,16.08322s-5.15073,5.95134-1.597,8.66937-6.41946,6.40346-1.36885,10.26636a14.49314,14.49314,0,0,1,5.29278,14.82919l15.51361-4.791L309.2603,490.468l6.14623-19.96163,16.42617-49.96295Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#cbcbcb"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M406.52257,395.9577l3.45575-10.68857s6.36417-2.60442,11.062,12.07165,6.92758,51.815,6.92758,51.815l9.12565,44.26975s3.40995,5.638,1.597,7.25428,7.96325,3.88845,2.28141,6.88228.49-.64482-1.633,6.18131c-1.39432,4.48328.036,6.8392.036,6.8392L421.808,517.04847l-4.791-22.6929-10.86718-42.19111Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#cbcbcb"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.51877,
    cy: 184.1408,
    r: 30.29763,
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M369.30141,313.42678a63.52848,63.52848,0,0,0-23.113-14.94617c-5.58711-2.06984-11.66837-3.34868-17.50945-2.17319-5.84127,1.17543-11.3651,5.21629-12.99467,10.94733-1.33247,4.68634.04335,9.73209,2.11139,14.14356,2.06784,4.41147,4.82873,8.50225,6.501,13.07836a29.8499,29.8499,0,0,1-30.03607,40.02848c5.73916.76954,11.02958,3.46657,16.63929,4.90218s12.23075,1.33822,16.39951-2.6807c4.4108-4.25213,4.49915-11.16564,4.28587-17.28857q-.47556-13.65279-.95111-27.30569c-.16171-4.6418-.29978-9.43236,1.37438-13.76483,1.67395-4.33247,5.65224-8.12625,10.29666-8.0868,3.5201.02985,6.63562,2.16231,9.45836,4.26528,2.82314,2.103,5.81086,4.34665,9.31719,4.65942,3.50612.31283,7.50948-2.28194,7.2471-5.79227Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#2f2e41"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.46158,
    cy: 343.41771,
    r: 22.30251,
    transform: "translate(-237.86069 360.00315) rotate(-61.33677)",
    fill: "#ffb7b7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M406.82673,341.73148H374.6224l-.33035-4.62357-1.65115,4.62357h-4.95878l-.65442-9.1638-3.27261,9.1638h-9.595v-.454a24.09021,24.09021,0,0,1,24.063-24.06317h4.54045a24.09039,24.09039,0,0,1,24.06319,24.06317Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#2f2e41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M359.02524,358.35076l-11.76-11.77265-1.98307-26.06094h25.95864l-.64266.64166C361.65641,330.089,352.003,343.19393,359.02524,358.35076Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#2f2e41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M513.89489,751.859h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-131.89489 -148.14101)",
    fill: "#cbcbcb"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawTravelBookingRe6Umu);
export default __webpack_public_path__ + "static/media/undraw_travel_booking_re_6umu.3d07b1575b3a96c11964c35a06ea2bc3.svg";
export { ForwardRef as ReactComponent };